export default [
  '/*/404*',
  '/download',
  '/giffgaff',
  '/inspiringbenefits',
  '/promotion/*',
  '/preview',
  '/boohoo',
  '/optum',
]